/**** cat.Branch */

const config = {
  schema: 'mgt',
  table: 'Agency',
  title: 'Предприятия перевозчиков',
  elemsOnPage: 10,
  fields: [
    {
      name: 'agency_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      hide: true,
    },
    {
      name: 'title',
      title: 'Название',
      type: 'text',
      hide: true,
    },
    {
      name: 'address',
      title: 'Адрес',
      type: 'text',
      required: false,
    },
    {
      name: 'phone',
      title: 'Телефон',
      type: 'text',
      required: false,
    },
    {
      name: 'ag_lat',
      title: 'Широта',
      type: 'text',
      required: false,
      hide: true,
      disableFilter: true,
    },
    {
      name: 'ag_lon',
      title: 'Долгота',
      type: 'text',
      required: false,
      hide: true,
      disableFilter: true,
    },
    {
      title: 'Координаты',
      type: 'map',
      disableFilter: true,
      composite: {
        type: 'point_coords',
        lat: 'ag_lat',
        lon: 'ag_lon',
      },
    },
  ],
  makeTitle: (elem: any, conections: { [key: string]: any }): string => {
    return elem['title'];
  },
  makeAdditional: (elem: any, conections: { [key: string]: any }): string => {
    return `Адрес: ${elem.address || '-'}; Телефон: ${elem.phone || '-'}`;
  },
  defaultSort: {
    field: 'agency_id',
    direction: 'desc',
  },
};

export default config;
